import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { getAllLuckNumAirDrop } from "../apis/services/steemActivity";
import LuckyNumAirDrop from "../components/LuckyNumAirDrop.vue";
export default {
  components: {
    LuckyNumAirDrop: LuckyNumAirDrop
  },
  data: function data() {
    return {
      luckNumAirDropList: null
    };
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAllLuckNumAirDrop();

            case 2:
              _this.luckNumAirDropList = _context.sent.data.items;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};